/**
 * Thrown when the server returns 403, indicating the user's account is disconnected.
 * Used to distinguish expected disconnection from real errors so that:
 * - Error toasts are suppressed
 * - Bugsnag reports are skipped
 * - Analytics events are not tracked
 */
export class DisconnectedError extends Error {
  constructor() {
    super("Account disconnected");
    this.name = "DisconnectedError";
  }
}

/**
 * Thrown when a subscribe request is cancelled because a newer one superseded it
 * (e.g. rapid item switches in pinned mode). Treated like DisconnectedError:
 * error toasts and Bugsnag reports are suppressed for the cancelled request.
 */
export class RequestAbortedError extends Error {
  constructor() {
    super("Request aborted");
    this.name = "RequestAbortedError";
  }
}
